import LinkImage from "./components/LinkImage"
export default LinkImage
